import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

function initializeTranslation(response) {
  let lng = localStorage.getItem('language') || 'en';
  let resources={};
  for(let key in response?.['web']){
    resources[key] = { translation: response?.['web']?.[key] || {} };
  }
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng,
      interpolation: { escapeValue: false },
    });
  // return i18n;
}

function translation() {
  return i18n;
}

function changeLanguage() {
  let lng = localStorage.getItem('language') || 'en';
  i18n.changeLanguage(lng);
}

export { initializeTranslation, translation, changeLanguage };
